
import { Component, Prop } from "vue-property-decorator";
import Base from "@/Base";
import { lectureService } from "@/service/api/LectureService";
import LectureInfoModel from "@/service/model/lecture/LectureInfoModel";

@Component({
  components: {
    UserDetailLectureEnrollment: () =>
      import(
        /* webpackChunkName : "UserDetailLectureEnrollment" */ "@/components/user/detail/lecture/enrollment/UserDetailLectureEnrollment.vue"
      ),
    UserDetailLectureList: () =>
      import(
        /* webpackChunkName : "UserDetailLectureList" */ "@/components/user/detail/lecture/UserDetailLectureList.vue"
      )
  }
})
export default class UserDetailLecture extends Base {
  @Prop()
  private userDetail!: UserDetail;
  @Prop()
  private organizationList!: Organization[];

  private lectureInfoList: LectureInfoModel[] = [];

  public mounted(): void {
    this.getLectureList();
  }

  private getLectureList(): void {
    lectureService
      .retrieveLectureIntoByUserId(this.userDetail.user.id)
      .subscribe((lectureInfoList: LectureInfo[]) => {
        this.lectureInfoList = lectureInfoList;
      });
  }
}
